import React from 'react';
import {StyleSheet, View} from 'react-native';

import {getSkeletonColors, STAGGER} from '../constants';
import {BoneIcon} from '../primitives/BoneIcon';
import {BoneImage} from '../primitives/BoneImage';
import {BoneText} from '../primitives/BoneText';

/**
 * Skeleton for promotion tiles (2-up grid layout).
 * Mirrors: BaseTile container + PromotionTile customStyles
 * Reference: app/components/articleTile/BaseTile.tsx (styles.container)
 */
export const PromotionCardSkeleton: React.FC = React.memo(() => (
  <View style={styles.container}>
    <BoneImage variant="banner" animationDelay={STAGGER.delay(0)} />
    <View style={styles.textBlock}>
      <BoneText variant="h1" width="85%" animationDelay={STAGGER.delay(1)} />
      <BoneText variant="body" width="70%" animationDelay={STAGGER.delay(2)} />
      <View style={styles.ctaRow}>
        <BoneText variant="caption" width={80} animationDelay={STAGGER.delay(3)} />
        <BoneIcon size={16} animationDelay={STAGGER.delay(3)} />
      </View>
    </View>
  </View>
));

PromotionCardSkeleton.displayName = 'PromotionCardSkeleton';

const styles = StyleSheet.create({
  container: {
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: getSkeletonColors().border,
    backgroundColor: getSkeletonColors().cardBackground,
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 5},
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
    elevation: 7,
  },
  textBlock: {
    padding: 12,
    gap: 6,
  },
  ctaRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    marginTop: 4,
  },
});
